import { gql } from "@apollo/client";

export default gql`
  mutation createQuickTopicMutation(
    $topicId: Int
    $meetingId: Int
    $title: String
    $assignee: Int
  ) {
    createOrUpdateTopic(
      topicId: $topicId
      meetingId: $meetingId
      title: $title
      assignee: $assignee
    ) {
      topic {
        id
        title
        state
        canDelete {
          permission
        }
      }
    }
  }
`;
